module.exports = __webpack_public_path__ + "img/逸居logo.2505d4e4.png";